<template>
  <div class="asd-form">
    <AttachmentsList :attachments="attachments"></AttachmentsList>
    <AttachmentsNew :id="entityId" evidence="project"></AttachmentsNew>
  </div>
</template>

<script>
import AttachmentsList from 'CORE/components/attachment/list'
import AttachmentsNew from 'CORE/components/attachment/new'

export default {
    name: 'ProjectAttachments',
    components: {
        AttachmentsList,
        AttachmentsNew,
    },
    props: {
        entityId: {
            type: String,
            required: true,
        },
    },
    computed: {
        attachments() {
            return this.$store.getters.attachmentByEntityId(this.entityId)
        },
    },
}
</script>

<style lang="scss">
    .attachments {
      max-height: 400px;
      overflow: auto;
    }
</style>
